import classNames from 'classnames';
import React from 'react';

import {ClickEvent, Tracker} from '@udemy/event-tracking';
import {useI18n} from '@udemy/i18n';
import {QuestionAndAnswer, QuestionsAndAnswers} from '@udemy/react-frequently-asked-questions';

import styles from './certification-prep-faq.module.less';

export const CertificationPrepFaq = () => {
    const {gettext} = useI18n();

    const q1 = {
        question: gettext('What is a Certification Preparation Course?'),
        answer: gettext(
            "Certification Preparation courses are designed to help individuals prepare for professional certification exams. Whether you're looking to jump into a new industry or upskill your current profession, these courses help equip you with the necessary knowledge, skills, and strategies needed to successfully pass certification assessments in a specific field or industry.",
        ),
    };

    const q2 = {
        question: gettext('What are Udemy Professional Certifications?'),
        answer: gettext(
            "Udemy Professional Certifications are certifications issued directly by Udemy upon successful completion of specific courses or programs. These certifications demonstrate that a learner has achieved a certain level of competence or expertise in a particular subject area as defined by a Udemy instructor's rigorous course criteria. While they are recognized within the Udemy ecosystem and by many employers for skills validation, it's important to note that they are distinct from certifications issued by independent professional organizations.",
        ),
    };

    const q3 = {
        question: gettext('What are 3rd party Certifications on Udemy?'),
        answer: gettext(
            '3rd Party Certifications on Udemy refer to professional certifications that are awarded by external organizations and industry bodies, rather than Udemy itself. Courses in this category are designed to help students prepare for these widely recognized certification exams. While the preparation courses are hosted on Udemy, the actual certification is granted by the third-party organization upon successful completion of their specific examination and requirements.',
        ),
    };

    const q4 = {
        question: gettext('What are Open Badges?'),
        answer: gettext(
            'Open Badges is a digital credentialing system developed by Mozilla, designed to recognize and verify skills, achievements, and competencies. Each badge contains detailed metadata that includes information about the issuing organization, the criteria required to earn the badge, and evidence demonstrating the accomplishment. Open Badges are shareable across various platforms, such as LinkedIn and social media, providing verifiable and portable recognition of learning and professional development.',
        ),
    };

    const q5 = {
        question: gettext('How long does it take to complete a Certification Preparation Course?'),
        answer: gettext(
            'The time required to complete a Certification Preparation Course on Udemy varies depending on the complexity of the subject matter and the specific course structure. Each course provides an estimate of the total hours of content, and all are self-paced, allowing you to progress through the material at a speed that fits your schedule.',
        ),
    };

    const q6 = {
        question: gettext(
            'What background knowledge do I need to take a Certification Preparation course?',
        ),
        answer: gettext(
            "The background knowledge required for a Certification Preparation Course on Udemy can vary widely depending on the certification you're aiming for. Some courses are designed for beginners with no prior experience in the field, while others may require a foundational understanding of certain concepts or previous professional experience. Each course description includes prerequisites and recommended knowledge, so be sure to check these details before enrolling to ensure you are well-prepared to tackle the course material effectively.",
        ),
    };

    const onQuestionToggled = (item: QuestionAndAnswer, index: number) => {
        Tracker.publishEvent(
            new ClickEvent({
                componentName: 'FrequentlyAskedQuestions',
                relatedObjectId: index,
            }),
        );
    };

    const faq: QuestionAndAnswer[] = [q1, q2, q3, q4, q5, q6];

    return (
        <QuestionsAndAnswers
            className={styles['faq-container']}
            headerClass={classNames('ud-heading-serif-xxl', styles['faq-header'])}
            questionsAndAnswers={faq}
            numRowsToShow="all"
            onQuestionToggled={onQuestionToggled}
        />
    );
};
